import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowRight, CheckCircle } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/ismail-haamud98/30min';

const CTASection = () => {
  const { language } = useLanguage();
  const sv = language === 'sv';
  const bullets = sv
    ? ['Gratis provlektion', 'Ingen förpliktelse', 'Personlig nivåbedömning']
    : ['Free trial lesson', 'No obligation', 'Personal level assessment'];

  return (
    <section className="py-24 islamic-pattern hero-gradient" data-testid="cta-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
          {sv ? 'Börja din Koranresa idag' : 'Start Your Quran Journey Today'}
        </h2>
        <p className="mb-8 max-w-xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
          {sv ? 'Ta det första steget. Boka en gratis provlektion och se hur vi kan hjälpa dig.' : 'Take the first step. Book a free trial lesson and see how we can help you.'}
        </p>
        <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="btn-gold inline-flex items-center gap-2 text-base py-4 px-10" data-testid="cta-apply">
          {sv ? 'Boka gratis provlektion' : 'Book Free Trial Lesson'} <ArrowRight size={20} />
        </a>
        <div className="flex flex-wrap justify-center gap-4 mt-6">
          {bullets.map((b, i) => (
            <span key={i} className="flex items-center gap-1.5 text-sm" style={{ color: 'var(--text-secondary)' }}>
              <CheckCircle size={14} className="text-gold" /> {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
